import { render, staticRenderFns } from "./TagIcon.vue?vue&type=template&id=fa6cf384"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa6cf384')) {
      api.createRecord('fa6cf384', component.options)
    } else {
      api.reload('fa6cf384', component.options)
    }
    module.hot.accept("./TagIcon.vue?vue&type=template&id=fa6cf384", function () {
      api.rerender('fa6cf384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/TagIcon.vue"
export default component.exports